import { Map as ImmMap } from 'immutable';
import {
	IS_FETCHING,
	LAST_FETCH_TIME,
	FETCH_ERROR,
	RECEIVE_ALL_CATEGORIES,
	RECEIVE_TOP_CATEGORIES,
	RECEIVE_TOP_FEATURED_IMAGES,
} from './constants';

export const initialState = new ImmMap({
	allCategories: new Map(),
	categories: [],
	isFetching: false,
	lastFetchTime: undefined,
	fetchError: undefined,
	topFeaturedImages: [],
});

const categoriesReducer = (state = initialState, action) => {
	switch (action.type) {
		case IS_FETCHING:
			return state.set('isFetching', action.isFetching);
		case LAST_FETCH_TIME:
			return state.set('lastFetchTime', action.lastFetchTime);
		case FETCH_ERROR:
			return state.set('fetchError', action.fetchError);
		case RECEIVE_ALL_CATEGORIES: {
			const allCategories = new Map();
			action.categories.forEach(category => {
				const { categoryId } = category;
				allCategories.set(categoryId, category);
			});
			return state.set('allCategories', allCategories);
		}
		case RECEIVE_TOP_CATEGORIES:
			return state.set('categories', action.categories);
		case RECEIVE_TOP_FEATURED_IMAGES:
			return state.set('topFeaturedImages', action.topFeaturedImages);
		default:
			return state;
	}
};

export default categoriesReducer;
